import type { FC } from 'react';
import { Checkbox as MuiCheckbox, FormControlLabelProps } from '@mui/material';

import { FormControlLabelStyled } from './styled';

type TFormControlLabelForwardProps = Pick<
	FormControlLabelProps,
	| 'checked'
	| 'onChange'
	| 'onBlur'
	| 'label'
	| 'name'
	| 'disabled'
	| 'inputRef'
	| 'labelPlacement'
	| 'sx'
>;

export interface ICheckboxProps extends TFormControlLabelForwardProps {
	checkboxTestId?: string;
	labelTestId?: string;
	className?: string;
}

export const Checkbox: FC<ICheckboxProps> = ({
	checkboxTestId,
	labelTestId,
	...formControlLabelProps
}) => {
	return (
		<FormControlLabelStyled
			control={<MuiCheckbox color="primary" data-testid={checkboxTestId} />}
			data-testid={labelTestId}
			{...formControlLabelProps}
		/>
	);
};
